var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIconButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5547_67233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.7025 44 44 33.7025 44 22C44 10.2975 34.7025 0 22 0C10.2975 0 0 10.2975 0 22C0 33.7025 10.2975 44 22 44Z",
    fill: "#604099"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22, 22) scale(0.935) translate(-8, -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9722 7.12963H8.55556V0.712963C8.55556 0.320833 8.23472 0 7.84259 0C7.45046 0 7.12963 0.320833 7.12963 0.712963V7.12963H0.712963C0.320833 7.12963 0 7.45046 0 7.84259C0 8.23472 0.320833 8.55556 0.712963 8.55556H7.12963V14.9722C7.12963 15.3644 7.45046 15.6852 7.84259 15.6852C8.23472 15.6852 8.55556 15.3644 8.55556 14.9722V8.55556H14.9722C15.3644 8.55556 15.6852 8.23472 15.6852 7.84259C15.6852 7.45046 15.3644 7.12963 14.9722 7.12963Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5547_67233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconButton);
export default __webpack_public_path__ + "static/media/add-icon-button.3175a04cfa139f3b5a004c7f6db7854e.svg";
export { ForwardRef as ReactComponent };